import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';

export function encriptMessage(message) {
	return CryptoAES.encrypt(message, document.getElementById("magic-key").getAttribute("key-value"));
}

export function decriptMessage(encriptedMessage) {
	let _ciphertext = CryptoAES.decrypt(encriptedMessage.toString(), document.getElementById("magic-key").getAttribute("key-value"));
	return _ciphertext.toString(CryptoENC);
}

export function generateFormId(length) {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const array = new Uint8Array(length);
	window.crypto.getRandomValues(array);
	let result = '';
	for (let i = 0; i < length; i++) {
		result += chars.charAt(array[i] % chars.length);
	}
	return result;
}
